









import { Component, Vue, Prop, Provide, Emit, Watch } from 'vue-property-decorator'
import { msgTip } from '@/utils/urlUtils'
import { AButton } from '../../components'
import mainTemplate from '@/components/MainTemplate.vue'
import Main from './components/Main.vue'
import QuestionBus from './components/QuestionBus.vue'
import UploadPhotos from './components/UploadPhotos.vue'

@Component({
  components: {
    mainTemplate,
    // eslint-disable-next-line vue/no-unused-components
    Main,
    QuestionBus,
    UploadPhotos
    // AButton
  }
})
export default class Question extends Vue {
  /**
   * name
   */
  public name() {}
  // token
  public get token() {
    return this.$route.query.token || null
  }
  // style
  public get style() {
    return this.$route.query.style || null
  }
  // mounted
  public mounted() {
    if (this.token) {
      if (this.style == 'wx') {
      } else if (this.style == 'qq') {
      } else {
      }
    }
  }
}
